import { Typography } from '@/shared/ui/Typography/Typography';
import { Button } from '@/shared/ui/Button';
import { Link } from 'react-router-dom';

type CookieBunnerProps = {
  visible?: boolean;
  handleAccept?: () => void;
};

export const CookieBanner = ({ visible, handleAccept }: CookieBunnerProps) => {
  if (!visible) return null;

  return (
    <div className="w-full rounded-b-[15px] bg-[#00212A33]">
      <div className="container relative m-auto flex flex-row items-center justify-between gap-[10px] px-[10px] py-[10px] md:px-[32px] 2xl:px-[180px] 3xl:px-[290px]">
        <Typography className="text-[8px] md:text-[10px] lg:text-[12px]">
          Мы используем файлы соокіе. Продолжая работу с сайтом, вы
          подтверждаете, что полностью ознакомились и согласны с условиями
          обработки файлов Cookie, изложенных в
          <Link to="/privacy-policy" className="text-[#116ACC]">
            {' Политике обработки персональных данных и файлов Cookie.'}
          </Link>
        </Typography>
        <Button
          text="Хорошо"
          className="bg-white p-[12px] text-[8px] md:text-[10px] lg:text-[12px]"
          onClick={handleAccept}
        />
      </div>
    </div>
  );
};
